import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';



import { BillRoutingModule } from './bill-routing.module';
import { LaaSSharedModule } from 'src/app/shared/laas-shared.module';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { FullCalendarModule } from '@fullcalendar/angular';
import { EvidenceCheckComponent } from './pages/evidence-check/evidence-check.component';
import { NoEvidenceCheckComponent } from './pages/no-evidence-check/no-evidence-check.component';
import { BillComponent } from './pages/bill/bill.component';
import { BillAddComponent } from './pages/bill/bill-add/bill-add.component';
import { BillImportComponent } from './pages/bill/bill-import/bill-import.component';

@NgModule({
  declarations: [
    EvidenceCheckComponent,
    NoEvidenceCheckComponent,
    BillComponent,
    BillAddComponent,
    BillImportComponent
  ],
  imports: [
    CommonModule,
    BillRoutingModule,
    LaaSSharedModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    FullCalendarModule
  ]

})

export class BillModule { }
